module.exports = __webpack_public_path__ + "img/004-edit-tools.6f4b08ae.png";